import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Avatar, Box, Chip, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ConversationListItem = function ConversationListItem(props) {
  var className = props.className,
      info = props.info,
      _props$isSelected = props.isSelected,
      isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
      onClick = props.onClick;

  var formatMessageTime = function formatMessageTime(value) {
    if (!value) {
      return '--:--';
    }

    var date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).format(date);
  }; // Get avatar initials fallback


  var getInitials = function getInitials(fullName) {
    return fullName.split(' ').map(function (n) {
      return n[0];
    }).join('').toUpperCase().slice(0, 2);
  }; // Get type chip styles


  var getTypeChipStyles = function getTypeChipStyles() {
    if ((info === null || info === void 0 ? void 0 : info.conversation_type) === 'ai') {
      return {
        label: 'AI',
        sx: {
          backgroundColor: '#FEF3C7',
          color: '#92400E',
          fontWeight: 600,
          fontSize: '0.75rem'
        }
      };
    } else {
      return {
        label: 'Agent',
        sx: {
          backgroundColor: '#F3E8FF',
          color: '#6B21A8',
          fontWeight: 600,
          fontSize: '0.75rem'
        }
      };
    }
  };

  var typeChipStyles = getTypeChipStyles();
  var acceptedByDisplayName = (info === null || info === void 0 ? void 0 : info.accepted_by_name) || (info === null || info === void 0 ? void 0 : info.accepted_by_email); // Source display config

  var getSourceConfig = function getSourceConfig(source) {
    var config = {
      quote: {
        label: 'Quote',
        color: '#1D4ED8',
        bgColor: '#DBEAFE'
      },
      validation: {
        label: 'Validation',
        color: '#047857',
        bgColor: '#D1FAE5'
      },
      website: {
        label: 'Website',
        color: '#6D28D9',
        bgColor: '#EDE9FE'
      },
      whatapp: {
        label: 'WhatsApp',
        color: '#075E54',
        bgColor: '#D4F5ED'
      }
    };
    return source ? config[source] : undefined;
  };

  var sourceConfig = getSourceConfig(info === null || info === void 0 ? void 0 : info.source);
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex cursor-pointer items-start gap-3 rounded-lg border border-transparent bg-white px-4 py-3', isSelected && 'border-blue-200 shadow-sm', className),
    sx: {
      position: 'relative',
      transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
      willChange: 'transform',
      '&:hover': {
        transform: 'translateY(-2px) scale(1.01)',
        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.08)'
      },
      '&:active': {
        transform: 'translateY(0) scale(0.995)',
        boxShadow: '0 4px 12px rgba(15, 23, 42, 0.08)'
      },
      '@media (prefers-reduced-motion: reduce)': {
        transition: 'none',
        '&:hover': {
          transform: 'none'
        },
        '&:active': {
          transform: 'none'
        }
      }
    },
    onClick: onClick,
    children: [info !== null && info !== void 0 && info.is_online ? /*#__PURE__*/_jsx(Box, {
      sx: {
        position: 'absolute',
        top: 8,
        right: 8,
        width: 14,
        height: 14,
        borderRadius: '9999px',
        backgroundColor: '#22C55E',
        border: '2px solid #FFFFFF',
        zIndex: 2,
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: -6,
          borderRadius: '9999px',
          border: '2px solid rgba(34, 197, 94, 0.45)',
          animation: 'onlinePulse 1.6s ease-out infinite'
        },
        '@keyframes onlinePulse': {
          '0%': {
            transform: 'scale(0.7)',
            opacity: 0.75
          },
          '70%': {
            transform: 'scale(1.55)',
            opacity: 0
          },
          '100%': {
            transform: 'scale(1.75)',
            opacity: 0
          }
        },
        '@media (prefers-reduced-motion: reduce)': {
          '&::after': {
            animation: 'none'
          }
        }
      }
    }) : null, /*#__PURE__*/_jsx(Box, {
      sx: {
        flexShrink: 0
      },
      children: /*#__PURE__*/_jsx(Avatar, {
        sx: {
          width: 40,
          height: 40,
          backgroundColor: '#3B82F6',
          color: 'white',
          fontWeight: 600,
          fontSize: '0.875rem'
        },
        alt: info === null || info === void 0 ? void 0 : info.name,
        src: info !== null && info !== void 0 && info.avatar && info.avatar.startsWith('http') ? info.avatar : undefined,
        children: !(info !== null && info !== void 0 && info.avatar) || !info.avatar.startsWith('http') ? getInitials((info === null || info === void 0 ? void 0 : info.customer_name) || '') : ''
      })
    }), /*#__PURE__*/_jsxs(Box, {
      className: "min-w-0 flex-1",
      children: [/*#__PURE__*/_jsxs(Box, {
        className: "mb-1 flex items-center justify-between",
        children: [/*#__PURE__*/_jsx(Typography, {
          sx: {
            fontWeight: 600,
            fontSize: '0.95rem',
            color: '#1F2937',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          },
          children: info === null || info === void 0 ? void 0 : info.name
        }), /*#__PURE__*/_jsx(Typography, {
          sx: {
            fontSize: '0.875rem',
            color: '#9CA3AF',
            flexShrink: 0,
            ml: 2
          },
          children: formatMessageTime(info === null || info === void 0 ? void 0 : info.last_message_time)
        }), info !== null && info !== void 0 && info.unread_count ? /*#__PURE__*/_jsx(Box, {
          sx: {
            ml: 1,
            minWidth: 20,
            height: 20,
            borderRadius: '9999px',
            backgroundColor: '#F43F5E',
            color: '#FFFFFF',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem',
            fontWeight: 600,
            lineHeight: 1,
            px: (info === null || info === void 0 ? void 0 : info.unread_count) > 9 ? 0.75 : 0
          },
          children: (info === null || info === void 0 ? void 0 : info.unread_count) > 99 ? '99+' : info === null || info === void 0 ? void 0 : info.unread_count
        }) : null]
      }), /*#__PURE__*/_jsx(Typography, {
        sx: {
          fontSize: '0.875rem',
          color: '#6B7280',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          mb: 1
        },
        children: info === null || info === void 0 ? void 0 : info.last_message_content
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex items-center gap-2",
        children: [typeChipStyles && /*#__PURE__*/_jsx(Chip, {
          label: typeChipStyles.label,
          size: "small",
          sx: _objectSpread(_objectSpread({}, typeChipStyles.sx), {}, {
            height: '20px',
            fontSize: '0.75rem'
          })
        }), sourceConfig && /*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: sourceConfig.bgColor,
            color: sourceConfig.color,
            borderRadius: '4px',
            px: 0.5,
            py: 0.25,
            fontSize: '0.7rem',
            fontWeight: 700,
            lineHeight: 1.4,
            whiteSpace: 'nowrap'
          },
          children: sourceConfig.label
        })]
      }), acceptedByDisplayName ? /*#__PURE__*/_jsxs(Typography, {
        sx: {
          mt: 0.75,
          fontSize: '0.75rem',
          color: '#64748B',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        },
        className: "text-brand-secondary",
        children: [/*#__PURE__*/_jsx(Box, {
          component: "span",
          sx: {
            fontWeight: 700
          },
          children: acceptedByDisplayName
        }), ' ', "is handling this chat"]
      }) : null]
    })]
  });
};

export default ConversationListItem;